<template>
  <el-dialog
    v-if="dialogVisible"
    aria-posinset="absolute"
    :visible.sync="dialogVisible"
    top="10vh"
    style="overflow: scroll;"
    :append-to-body="true"
    class="before-register"
  >
    <div id="feedback" />
  </el-dialog>
</template>

<script>
// import { SF_BUY } from '@/utils/constant'
import { initFeedback } from '@/utils'

export default {
  // 隐私政策，服务条款，cookies政策对话框组件
  name: 'FeedbackDialog',
  props: {
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showData(row) {
      this.dialogVisible = true
      setTimeout(() => {
        initFeedback(() => {
          this.dialogVisible = false
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
  ::v-deep .el-dialog__body {
    overflow: scroll;
  }
  ::v-deep .nav_rigth {
    display: none;
  }

</style>
